// extracted by mini-css-extract-plugin
module.exports = {"quiz":"Quiz_quiz__y2h-U","error":"Quiz_error__2gcbG","quizWrapper":"Quiz_quizWrapper__2ZJAj"};